import {
  getPartySignatory,
  SignatoryStatus,
  getSignatories
} from '../dataAccess/parties'

export function allowSigning(document, { uid, emailVerified, mfaEnabled }) {
  const decision = {
    value: false,
    reason: "Can't sign"
  }

  const { isCounterParty, isFirstParty, signatory } = getDocumentSignatory(
    document,
    uid
  )
  if (!signatory) {
    decision.value = false
    decision.reason = 'You are not a signatory of this document'
    return decision
  }

  if (isCounterParty && !isCounterpartyStage(document)) {
    decision.value = false
    decision.reason = 'Not in counter party stage'
    return decision
  }

  if (isFirstParty && !isSigningStage(document)) {
    decision.value = false
    decision.reason = 'Not in signature stage'
    return decision
  }

  if (isFirstParty) {
    if (!emailVerified) {
      decision.value = false
      decision.reason = 'You cannot sign documents until your email is verified'
      return decision
    }

    if (!mfaEnabled) {
      decision.value = false
      decision.reason =
        'You cannot sign documents until you have enabled multi-factor authentication'
      return decision
    }
  }

  if (signatory.status === SignatoryStatus.Signed) {
    // Already signed by current user
    decision.value = false
    decision.reason = 'Already signed'
    return decision
  }

  decision.value = true
  decision.reason = 'Waiting to be signed by you'
  return decision
}

function getDocumentSignatory(document, uid) {
  const firstPartySignatory = getPartySignatory(document.firstParty, uid)
  if (firstPartySignatory) {
    return { isFirstParty: true, signatory: firstPartySignatory }
  }
  const counterPartySignatory = getPartySignatory(
    {
      signatories: getSignatories(document.counterParties)
    },
    uid
  )
  if (counterPartySignatory) {
    return { isCounterParty: true, signatory: counterPartySignatory }
  }
  return {}
}

const isStage = (stage) => (document) => document.stage.toLowerCase() === stage

const SIGNATURE_STAGE = 'signature'
const isSigningStage = isStage(SIGNATURE_STAGE)

const COUNTERPARTY_STAGE = 'counterparty'
const isCounterpartyStage = isStage(COUNTERPARTY_STAGE)

const NEGOTIATION_STAGE = 'negotiation'
const isNegotiationStage = isStage(NEGOTIATION_STAGE)

export function allowUpload(document, { uid }) {
  if (!isNegotiationStage(document)) {
    return {
      value: false,
      reason: 'New versions can only be uploaded in the Negotiation stage'
    }
  }
  const { isFirstParty } = getDocumentSignatory(document, uid)
  if (!isFirstParty) {
    return {
      value: false,
      reason: 'Only the first party can upload a new version of the document'
    }
  }
  return { value: true, reason: 'Upload new version' }
}

const VERSION_UPDATED = 'Version updated'
export function getDocumentStatusDisplay({ status, version }) {
  if (status === VERSION_UPDATED) {
    return `${status} (v${version})`
  }
  return status
}
